import React, { useEffect, useState, useContext } from 'react';

import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";

export default function Dashboard({ history }) {

  const session = useContext(SessionContext);

  const [imgbemvindo, set_imgbemvindo] = React.useState("");

  useEffect(() => {
    set_imgbemvindo(process.env.REACT_APP_API_ENDPOINT + "anexos/" + session.logoGrande);
  }, [session]);

  const [alertaBloqueioFinanceiro, setalertaBloqueioFinanceiro] = React.useState(false);

  const [alertDemonstrativoAnual, setalertDemonstrativoAnual] = React.useState(false);

  const [qtdVendasPendentes, setQtdVendasPendentes] = React.useState(0);



  useEffect(() => {
    loadAlertas();
  }, []);

  const loadAlertas = () => {
    UseGetApiSimple("estabelecimentos/bloqueiofinanceiro/" + session.estabelecimentoId).then(function (retorno) {
      setalertaBloqueioFinanceiro(retorno.data);
    });
    UseGetApiSimple("estabelecimentos/GetAlertVendasProcessamentoPendente/" + session.estabelecimentoId).then(function (retorno) {
      setQtdVendasPendentes(retorno.data)
    });
    setalertDemonstrativoAnual(true);

  }

  return (
    <div>

      {alertaBloqueioFinanceiro &&

        <SnackbarContent
          color={"danger"}
          message={"Existem pendências financeiras para serem acordadas com seu franqueador. Para mais informações, entre em contato com a Matriz."}
        />

      }

      {alertDemonstrativoAnual &&

        <SnackbarContent
          color={"info"}
          message={"Está disponível o informe de rendimentos. Acessar Relatorios>> DEMONSTRATIVO ANUAL."}
        />

      }

      {qtdVendasPendentes > 0 &&

        <SnackbarContent
          color={"warning"}
          message={(qtdVendasPendentes > 1 ? "Existem " : "Existe ") + qtdVendasPendentes + (qtdVendasPendentes > 1 ? " contratos" : " contrato") + " com pagamento pendente."}
          buttonText="Ver todos"
          buttonAction={() => history.push('/adminclinic/vemandamento')}
        />

      }

      <center>
        <div style={{ padding: '20px', background: '#ffffffeb', borderRadius: '10px', maxWidth: '550px', margin: '100px auto' }}>
          <img alt="logo" style={{ width: '100%' }} src={imgbemvindo} />
        </div>
      </center>

    </div>
  );
}
